/*
 * Jira Ticket:
 * Created Date: Wed, 15th Apr 2020, 10:32:57 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getListSubcontractQuery = gql`
  query allSubcontracts(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: SubcontractFilter
  ) {
    items: allSubcontracts(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      id
      role
      organisation {
        id
        name
      }
      contractor {
        id
        name
      }
      subcontractor {
        id
        name
      }
      projects {
        id
        name
      }
      allowSubcontracting
      status
      statistics {
        numberOfUsers
      }
    }
    total: _allSubcontractsMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
    }
  }
`;

export default ({ client, params }) => {
  try {
    if (params.target && params.id) {
      // migrate reference_many props (target, id) to the filter
      const filterVar = [params.target] + 'Id';
      params.filter = { ...params.filter, [filterVar]: params.id };
      delete params.target;
      delete params.id;
    }
    if (
      params.filter &&
      params.filter.status &&
      typeof params.filter.status === 'string'
    ) {
      // handle when the user selects from the filter, as we are already adding the status filter to search for "PENDING" and "ACCEPTED" by default (requirement 2.3.7)
      params.filter.status = [params.filter.status];
    }
    return client.query({
      query: getListSubcontractQuery,
      variables: {
        filter: params.filter,
        sortField: params.sort.field,
        sortOrder: params.sort.order,
        page: !params.pagination.page ? 0 : params.pagination.page - 1,
        perPage: params.pagination.perPage,
      },
      fetchPolicy: 'network-only',
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
